import { useId } from "react";
import { AdjustFontSizeToFitContent } from "@/view/utils/useAdjustFontSizeToFitContent/useAdjustFontSizeToFitContent";

import { ORGANIZER_DIRECTIONS_MAX_LENGTH } from "./OrganizerDirections.constants";
import {
  directionsLabel,
  textareaCss,
  directionsTextareaCssWrapper,
  paragraphCss,
} from "./OrganizerDirections.styles";

interface OrganizerDirectionsProps {
  name: string;
  value: string;
  viewName?: string;
  handleChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  isStudent: boolean;
}

const OrganizerDirections = ({
  name,
  value,
  viewName = name,
  handleChange,
  isStudent,
}: OrganizerDirectionsProps) => {
  const id = useId();
  const formattedName = name.toLowerCase().replace(/\s+/g, "-");
  const qaSelector = `exportables-${formattedName}-directions-input`;

  return (
    <div css={directionsTextareaCssWrapper}>
      <label htmlFor={id} css={directionsLabel}>
        Directions
      </label>
      <AdjustFontSizeToFitContent deps={[value]}>
        {isStudent ? (
          <p css={paragraphCss}>{value}</p>
        ) : (
          <textarea
            id={id}
            data-qa-selector={qaSelector}
            value={value}
            onChange={handleChange}
            aria-label={`${viewName} organizer directions`}
            css={textareaCss}
            maxLength={ORGANIZER_DIRECTIONS_MAX_LENGTH}
          />
        )}
      </AdjustFontSizeToFitContent>
    </div>
  );
};

export default OrganizerDirections;
